import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./PlatfromSettingCRUD";
import { platformSettingSlice } from "./PlatfromSettingSlice";

const { actions } = platformSettingSlice;

export const callGameSuspendList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkGameSuspendList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.gameSuspendListFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkGameSuspendList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const updateSuspendActiveStatus = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkGameSuspendList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.suspendActiveFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkGameSuspendList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
